<template lang="pug">
  nav#breadcrumb(aria-label="breadcrumb" role="navigation")
    ol.breadcrumb
      li.breadcrumb-item: router-link(:to="{ name: 'Index' }") {{ this.inicio }}
      template(v-if="itens.length" v-for="item of itens")
        li.breadcrumb-item(v-if="item.rota"): router-link(:to="{ name: item.rota }") {{ item.nome }}
        li.breadcrumb-item(v-else) {{ item.nome }}
</template>

<style lang="scss">
  #breadcrumb {
    margin: 40px 0;

    .breadcrumb {
      @include media("<desktop") {
        margin-top: 50px;
      }
    }

    &.hotsite {
      display: none;
    }

    @include media(">=desktop") {
      margin: 40px 25px 40px 0;

      &.hotsite {
        margin: 40px 25px 0 0;
        display: block;
        > .breadcrumb { margin: 0; }
      }
    }

    @include media("print") {
      display: none;
    }
  }
</style>

<script>
export default {
  props: ['itens'],
  data () {
    return {
      inicio: 'Início'
    }
  },
  mounted () {
    let rotas = ['DCF', 'DGC', 'DGI', 'DCOM', 'DSP', 'CGT', 'ASTEC']
    rotas.forEach(rota => {
      if (this.$route.name.includes(rota)) {
        this.inicio = 'Início - PROAD'
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?db228160